<template>
  <div class="password-page">
    <form class="password-panel" @submit.prevent="submit">
      <div class="panel-mark">密</div>
      <h1>更换初始密码</h1>
      <p>设置完成后，当前账号的其他登录会话会一并退出。</p>
      <label><span>原密码</span><input v-model="form.currentPassword" type="password" autocomplete="current-password" /></label>
      <label><span>新密码</span><input v-model="form.newPassword" type="password" autocomplete="new-password" /></label>
      <label><span>确认新密码</span><input v-model="confirmPassword" type="password" autocomplete="new-password" /></label>
      <div v-if="message" class="form-message" :class="{ 'form-message--error': isError }">{{ message }}</div>
      <button type="submit" :disabled="loading">{{ loading ? "正在保存..." : "保存新密码" }}</button>
    </form>
  </div>
</template>

<script>
import { changeAdminPassword } from "../api/adminAuth"
import { clearAdminSession } from "../utils/adminSession"

export default {
  name: "ChangePasswordView",
  data() {
    return { form: { currentPassword: "", newPassword: "" }, confirmPassword: "", loading: false, message: "", isError: false }
  },
  methods: {
    async submit() {
      if (this.form.newPassword.length < 10) return this.showError("新密码至少 10 位")
      if (this.form.newPassword !== this.confirmPassword) return this.showError("两次输入的新密码不一致")
      this.loading = true
      this.message = ""
      try {
        await changeAdminPassword(this.form)
        clearAdminSession()
        this.$router.replace("/login")
      } catch (error) {
        this.showError(error.message || "密码修改失败")
      } finally {
        this.loading = false
      }
    },
    showError(message) { this.message = message; this.isError = true }
  }
}
</script>

<style scoped>
.password-page { min-height: 100vh; display: grid; place-items: center; padding: 24px; background: #f3f5f7; }
.password-panel { width: min(420px, 100%); padding: 30px; border: 1px solid #dfe4ea; border-radius: 8px; background: #fff; }
.panel-mark { width: 44px; height: 44px; display: grid; place-items: center; border-radius: 8px; background: #1f6b4f; color: #fff; font-weight: 800; }
h1 { margin: 18px 0 0; color: #17202b; font-size: 22px; letter-spacing: 0; }
p { margin: 8px 0 20px; color: #73808f; font-size: 13px; line-height: 1.7; }
label { display: block; margin-top: 15px; }
label span { display: block; margin-bottom: 6px; color: #394655; font-size: 13px; font-weight: 600; }
input { width: 100%; height: 42px; padding: 0 12px; border: 1px solid #cfd7df; border-radius: 6px; outline: none; }
input:focus { border-color: #1f6b4f; box-shadow: 0 0 0 3px rgba(31,107,79,.1); }
button { width: 100%; height: 42px; margin-top: 20px; border: 0; border-radius: 6px; background: #1f6b4f; color: #fff; font-weight: 700; cursor: pointer; }
.form-message { margin-top: 12px; font-size: 13px; color: #1f6b4f; }
.form-message--error { color: #b43b2d; }
</style>
